import React from 'react';
import Directory from './Directory';

export default function WorkerList() {
  return <Directory />;
}
